"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _modals = require("./modals");
Object.keys(_modals).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _modals[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _modals[key];
    }
  });
});
var _pages = require("./pages");
Object.keys(_pages).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _pages[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _pages[key];
    }
  });
});